import API from "./api";
import { BuyAndSell_API_URLS } from "./constants";

export function getListings(args) {
  return API.post(BuyAndSell_API_URLS.getListingsUrl, args);
}
